module.exports = __webpack_public_path__ + "img/pic1.bd70a812.png";